export default class PriceConditionController {

    priceConditions = [];
    selectedItems = [];
    ItemsList = [];

    constructor(priceConditions, selectedItems, ItemsList) {
        this.priceConditions = priceConditions
        this.selectedItems = selectedItems;
        this.ItemsList = ItemsList;
    }

    getConditionPrice(defaultPrice) {

        if (this.priceConditions.length === 0) {
            return defaultPrice;
        }

        this.priceConditions.forEach((condition) => {

            const conField = condition.field;
            const conOptions = condition.options;
            const price = condition.price;

            if (this.isConditionFieldExistInForm(conField)) {
                if (this.isConditionFieldWasSelected(conField)) {
                    const selectedProductField = this.getSelectedProductField(conField);
                    const isSelected = this.isPriceConditionOptionsContainsSelectedOption(selectedProductField.selectedOption, conOptions)
                    
                    if (isSelected) {
                        defaultPrice = parseFloat(price)
                        return;
                    }
                }
            }
        });

        return defaultPrice;
    }

    getSelectedProductField(conField) {
        return this.selectedItems.find(field => {
            return parseInt(field.id) === parseInt(conField.id);
        })
    }

    isConditionFieldExistInForm(conField) {
        return !!this.ItemsList.find(field => {
            return parseInt(field.id) === parseInt(conField.id);
        })
    }

    isPriceConditionOptionsContainsSelectedOption(selectedField, conditionOptions) {
        return !!conditionOptions.map(condition => condition.label).includes(selectedField.label)
    }

    isConditionFieldWasSelected(conField) {
        return !!this.selectedItems.find(field => {
            return parseInt(field.id) === parseInt(conField.id);
        })
    }

    // isFieldOptionShouldBeDisplayed(field) {
    //
    //     if (field.display_conditions.length === 0) {
    //         return field;
    //     }
    //
    //     let useFieldInCalculation = [];
    //
    //     //check each condition in config
    //     field.display_conditions.forEach((condition) => {
    //
    //         const conField = condition.field;
    //         const conOptions = condition.options;
    //
    //         //Field don`t exist in form, so we display all options.
    //         if (!this.isConditionFieldExistInForm(conField)) {
    //             useFieldInCalculation.push(true);
    //         } else {
    //             // If condition field was`t selected display all fields 
    //             if (!this.isConditionFieldWasSelected(conField)) {
    //                 useFieldInCalculation.push(true);
    //             } else {
    //
    //                 const selectedProductField = this.getSelectedProductField(conField);
    //                 const isSelected = this.isPriceConditionOptionsContainsSelectedOption(selectedProductField.selectedOption, conOptions)
    //
    //                 useFieldInCalculation.push(isSelected);
    //             }
    //         }
    //     });
    //
    //     return useFieldInCalculation.every((e) => e === true) ? field : false;
    // }


}